import { Grid, Skeleton, Stack } from '@mantine/core';
import React from 'react';

const LoaderApprovalCourse = () => {
  return (
    <Stack>
      <Stack gap={8}>
        <Skeleton h={24} w={'15%'} />
        <Skeleton h={24} w={'30%'} />
      </Stack>
      <Grid>
        <Grid.Col span={{ base: 12, md: 8 }}>
          <Stack gap={16}>
            {[...Array(3)].map((_, index) => (
              <Skeleton h={500} w={'100%'} key={index} />
            ))}
          </Stack>
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 2 }}>
          <Stack gap={16}>
            {[...Array(2)].map((_, index) => (
              <Skeleton h={200} w={'100%'} key={index} />
            ))}
          </Stack>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};

export default LoaderApprovalCourse;
